module.exports = __webpack_public_path__ + "static/media/Legenda_port.d77c400b.svg";